// import Rodal from 'rodal';
// import Rodal from "./rodal.js";
// import "./rodal.css";
import "./index.less";
import "./rodal.css";
import WeaNewScroll from "../wea-new-scroll";
import middleware from "../../middleware";
import Loadable from "../../react-loadable";

const Rodal = Loadable({
  loader: () => import("./rodal.js"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
class WeaSlideModal extends React.Component {
  render() {
    const {
      direction = "right",
      title = "",
      content,
      top = 0,
      hasScroll = true,
      className = "",
      style
    } = this.props;
    const animation = direction === "left" ? "slideLeft" : "slideRight";
    return (
      <div className={`wea-slide-modal ${className}`} style={style}>
        <Rodal
          {...this.props}
          animation={animation}
          enterAnimation={animation}
          leaveAnimation={animation}
          showCloseButton
          closeOnEsc={false}
          customMaskStyles={{}}
        >
          {title && (
            <div className="wea-slide-modal-title wea-f14">{title}</div>
          )}
          <div style={{ height: "100%", paddingBottom: top + 52 }}>
            {hasScroll ? (
              <WeaNewScroll height={"100%"}>
                {content && (
                  <div className="wea-slide-modal-content">{content}</div>
                )}
              </WeaNewScroll>
            ) : (
              <div className="wea-slide-modal-content">{content}</div>
            )}
          </div>
        </Rodal>
      </div>
    );
  }
}

const Com = middleware(WeaSlideModal, "WeaSlideModal");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-slide-modal/index.js